import { Progress } from 'antd';

interface Props {
  value: number | null | undefined;
  max: number | null | undefined;
  color?: string;
}

export function ProgressBarCellRenderer({ value, max, color }: Props) {
  if (value == null || max == null || max === 0) {
    return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  }
  const pct = Math.max(0, Math.min(100, Math.round((value / max) * 100)));
  return <Progress percent={pct} size="small" strokeColor={color} style={{ marginBottom: 0 }} />;
}
